import React from 'react';
import {connect} from 'react-redux';

import {trackEvent} from 'analytics/Analytics';
import BenchlingConfig from 'BenchlingConfig';
import {RESULTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {BenchlingState} from 'redux-stores/reduceApp';
import {BenchlingDispatch} from 'redux-stores/Store';
import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import ListingFiltersContainer from 'search/filters/ListingFiltersContainer';
import {Filter, FilterKey} from 'search/SearchConstants';

import {changeFilters} from './RunsInboxModalReduxActions';

interface ConnectedProps {
  filters: Array<Filter>;
}

function mapStateToProps(state: BenchlingState): ConnectedProps {
  return {
    filters: state.ui.results.runsInboxModal.filters,
  };
}

interface DispatchProps {
  onChangeFilters: (filters: Array<Filter>) => void;
}

function mapDispatchToProps(dispatch: BenchlingDispatch): DispatchProps {
  return {
    onChangeFilters: (filters: Array<Filter>) => {
      dispatch(changeFilters(filters));
    },
  };
}

interface BaseProps {
  assayRunSchema: AssaySchema;
}

export type RunsInboxFiltersProps = BaseProps & ConnectedProps & DispatchProps;

interface State {
  isSecondaryDropdownOpen: boolean;
}

export class RunsInboxFilters extends React.PureComponent<RunsInboxFiltersProps, State> {
  state: State = {
    isSecondaryDropdownOpen: false,
  };

  _handleChangeFilters(filters: Array<Filter>): void {
    for (const filter of filters) {
      switch (filter.key) {
        case FilterKey.RUN_AVAILABILITY:
          trackEvent(RESULTS_ANALYTICS_ACTIONS.CHANGED_RUNS_INBOX_IN_ENTRY_FILTER, {
            value: filter.value,
          });
          break;
        case FilterKey.ARCHIVE_PURPOSES:
          trackEvent(RESULTS_ANALYTICS_ACTIONS.CHANGED_RUNS_INBOX_ARCHIVE_FILTER, {
            value: filter.value,
          });
          break;
        default:
          break;
      }
    }
    this.props.onChangeFilters(filters);
  }

  private handleSetSecondaryDropdownOpen = (isDropdownOpen: boolean): void => {
    this.setState({isSecondaryDropdownOpen: isDropdownOpen});
  };

  render(): JSX.Element {
    return (
      <div className="u-flex-display u-spacing-bottom">
        <ListingFiltersContainer
          primaryFilterOptions={[
            {filterKey: FilterKey.RUN_AVAILABILITY},
            {
              filterKey: FilterKey.ARCHIVE_PURPOSES,
              extraProps: {archivePurposes: BenchlingConfig.ARCHIVE_RUN_AND_RESULT_PURPOSES},
            },
          ]}
          secondaryFilterProps={{
            filterGroups: [
              {
                name: 'General',
                filterOptions: [
                  {filterKey: FilterKey.CREATED_AT},
                  {filterKey: FilterKey.MODIFIED_AT},
                  {filterKey: FilterKey.CREATOR},
                  {
                    filterKey: FilterKey.SCHEMA_FIELD,
                    extraProps: {
                      allowBlobLinkFields: true,
                      schemaFields: this.props.assayRunSchema ? this.props.assayRunSchema.fields : [],
                    },
                  },
                ],
              },
            ],
            isDropdownOpen: this.state.isSecondaryDropdownOpen,
            onSetDropdownOpen: this.handleSetSecondaryDropdownOpen,
          }}
          filters={this.props.filters}
          onChangeFilters={(filters: Array<Filter>) => {
            this._handleChangeFilters(filters);
          }}
          selectedSchema={this.props.assayRunSchema}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RunsInboxFilters);
